(function () {
  const INIT_ATTR = 'data-product-videos-init';

  function initProductVideosSection(sectionEl) {
    if (!sectionEl || sectionEl.hasAttribute(INIT_ATTR)) return;
    sectionEl.setAttribute(INIT_ATTR, '');

    const sectionId =
      sectionEl.dataset.sectionId ||
      sectionEl.id.replace(/^ProductVideos-?/, '') ||
      '';
    const track = sectionEl.querySelector('[data-carousel-track]');
    const prevBtn = sectionEl.querySelector('[data-carousel-prev]');
    const nextBtn = sectionEl.querySelector('[data-carousel-next]');
    const modal =
      (sectionId && document.getElementById('ProductVideosModal-' + sectionId)) ||
      sectionEl.querySelector('.product-videos-modal[data-videos-modal]') ||
      sectionEl.parentElement?.querySelector(
        '.product-videos-modal[data-videos-modal]#ProductVideosModal-' + sectionId
      ) ||
      sectionEl.parentElement?.querySelector('.product-videos-modal[data-videos-modal]');

    if (!track || !modal) return;

    const openButtons = sectionEl.querySelectorAll('[data-video-open]');
    const closeHandlers = modal.querySelectorAll('[data-modal-close]');
    const modalPrev = modal.querySelector('[data-modal-prev]');
    const modalNext = modal.querySelector('[data-modal-next]');
    const slides = modal.querySelectorAll('[data-modal-slide]');
    const totalSlides = slides.length;

    let currentIndex = 0;

    function scrollCarousel(direction) {
      const w = track.clientWidth || track.getBoundingClientRect().width;
      const scrollAmount = Math.max(1, w * 0.8);
      track.scrollBy({ left: direction === 'next' ? scrollAmount : -scrollAmount, behavior: 'smooth' });
    }

    function updateCarouselArrows() {
      if (!prevBtn || !nextBtn) return;
      const w = track.clientWidth;
      if (w <= 0) return;
      const maxScroll = Math.max(0, track.scrollWidth - w);
      const left = track.scrollLeft;
      prevBtn.disabled = left <= 0;
      nextBtn.disabled = maxScroll <= 0 || left >= maxScroll - 2;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => scrollCarousel('prev'));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollCarousel('next'));
    track.addEventListener('scroll', updateCarouselArrows);
    updateCarouselArrows();
    window.addEventListener('load', () => {
      requestAnimationFrame(updateCarouselArrows);
    });
    let resizeT;
    window.addEventListener('resize', () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(() => requestAnimationFrame(updateCarouselArrows), 50);
    });
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => requestAnimationFrame(updateCarouselArrows));
      ro.observe(track);
    }
    track.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      const onDimChange = () => requestAnimationFrame(updateCarouselArrows);
      img.addEventListener('load', onDimChange, { passive: true });
      img.addEventListener('error', onDimChange, { passive: true });
    });
    requestAnimationFrame(() => {
      requestAnimationFrame(updateCarouselArrows);
    });
    setTimeout(updateCarouselArrows, 100);
    setTimeout(updateCarouselArrows, 400);

    function showModal(index) {
      pauseAllVideos();
      currentIndex = Math.max(0, Math.min(index, totalSlides - 1));
      slides.forEach((el, i) => el.classList.toggle('is-active', i === currentIndex));
      modal.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
      updateModalArrows();
      resetActivePoster();
    }

    function hideModal() {
      modal.setAttribute('hidden', '');
      document.body.classList.remove('overflow-hidden');
      pauseAllVideos();
    }

    function updateModalArrows() {
      if (modalPrev) modalPrev.disabled = currentIndex <= 0;
      if (modalNext) modalNext.disabled = currentIndex >= totalSlides - 1;
    }

    function resetActivePoster() {
      const activeSlide = modal.querySelector('.product-videos-modal__slide.is-active');
      if (!activeSlide) return;
      const video = activeSlide.querySelector('[data-modal-video]');
      const poster = activeSlide.querySelector('[data-poster]');
      if (video && poster) {
        poster.classList.remove('is-hidden');
        video.pause();
        if (video.dataset.sourcesLoaded) video.currentTime = 0;
      }
    }

    function pauseAllVideos() {
      modal.querySelectorAll('[data-modal-video]').forEach((v) => {
        v.pause();
      });
    }

    function resolveModalSlideIndexFromOpenButton(btn) {
      const rawKey = btn.dataset.slideId ?? btn.dataset.index;
      if (rawKey === undefined || String(rawKey).trim() === '') return -1;
      const trimmed = String(rawKey).trim();
      const parsed = parseInt(trimmed, 10);
      const hasNumericId = !Number.isNaN(parsed);

      return Array.from(slides).findIndex((slide) => {
        const slideKey = slide.dataset.slideId ?? slide.dataset.index;
        if (slideKey === undefined || String(slideKey).trim() === '') return false;
        const sTrim = String(slideKey).trim();
        if (sTrim === trimmed) return true;
        if (hasNumericId) {
          const slideParsed = parseInt(sTrim, 10);
          return !Number.isNaN(slideParsed) && slideParsed === parsed;
        }
        return false;
      });
    }

    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const slideIndex = resolveModalSlideIndexFromOpenButton(btn);
        if (slideIndex >= 0) showModal(slideIndex);
      });
    });

    function goPrev() {
      if (currentIndex > 0) showModal(currentIndex - 1);
    }

    function goNext() {
      if (currentIndex < totalSlides - 1) showModal(currentIndex + 1);
    }

    if (modalPrev) modalPrev.addEventListener('click', goPrev);
    if (modalNext) modalNext.addEventListener('click', goNext);

    closeHandlers.forEach((el) => el.addEventListener('click', hideModal));

    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') hideModal();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    });

    slides.forEach((slide) => {
      const video = slide.querySelector('[data-modal-video]');
      const poster = slide.querySelector('[data-poster]');
      const playBtn = slide.querySelector('[data-play-btn]');
      const sourcesTemplate = slide.querySelector('[data-video-sources]');
      if (!video || !poster || !playBtn) return;

      function loadSourcesIfNeeded() {
        if (video.dataset.sourcesLoaded || !sourcesTemplate) return;
        video.dataset.sourcesLoaded = 'true';
        video.appendChild(sourcesTemplate.content.cloneNode(true));
        video.load();
      }

      playBtn.addEventListener('click', () => {
        loadSourcesIfNeeded();
        video.play();
        poster.classList.add('is-hidden');
      });

      video.addEventListener('play', () => poster.classList.add('is-hidden'));
      video.addEventListener('pause', () => {
        if (video.currentTime === 0 || video.ended) poster.classList.remove('is-hidden');
      });
      video.addEventListener('ended', () => poster.classList.remove('is-hidden'));
    });
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product-videos[data-section-id]').forEach(initProductVideosSection);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
